import { useEffect, useState } from "react";
import { createFileRoute, useRouter } from "@tanstack/react-router";

import { Button } from "@/components/ui/button";
import { connexion, traiterRetourConnexion } from "@/auth/oidc";

/** Retour de Keycloak : échange du code, puis retour là où l'on était parti. */
export const Route = createFileRoute("/auth/callback")({
  component: RetourConnexion,
});

function RetourConnexion() {
  const router = useRouter();
  const [echec, setEchec] = useState(false);

  useEffect(() => {
    traiterRetourConnexion()
      .then((chemin) => router.history.replace(chemin))
      .catch((err: unknown) => {
        // Code déjà consommé, état perdu (onglet rechargé), session expirée entre-temps…
        console.warn("Retour de connexion inexploitable", err);
        setEchec(true);
      });
  }, [router]);

  return (
    <main className="flex min-h-svh flex-col items-center justify-center gap-4 p-6 text-sm">
      {echec ? (
        <>
          <p>La connexion n'a pas pu aboutir.</p>
          <Button size="sm" onClick={() => void connexion("/planning")}>
            Se reconnecter
          </Button>
        </>
      ) : (
        <p className="text-muted-foreground">Connexion en cours…</p>
      )}
    </main>
  );
}
